module.exports = __webpack_public_path__ + "static/media/WBTC-AVAX.3b52e7c7.svg";